module.exports = __webpack_public_path__ + "media/images/favicon/ms-icon-150x150-c8fd1cf443cd72b7c858d12b2a706fbc.png";